import { useAppSelector } from "../../hooks/StoreHooks";

export const useWalletList = () =>
  useAppSelector((state) => state.wallet.walletList);

export const useWalletDetails = () =>
  useAppSelector((state) => state.wallet.walletDetails);

export const useUserWalletDetails = () =>
  useAppSelector((state) => state.wallet.userWalletDetails);

export const useWalletTransactions = () =>
  useAppSelector((state) => state.wallet.walletTransactions);